export * from './lib/shared-feature-tenant-data-access';
